import React, { ReactNode } from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { config } from '../index';

export interface ModalProps {
  /* Modal background color */
  background?: string;
  /* Modal content background color */
  backgroundColor?: string;
  /* Modal width */
  width?: string;
  /* Modal max width */
  maxWidth?: string;
  /* Modal min width */
  minWidth?: string;
  /* Modal child components */
  children?: ReactNode;
}

const StyledWrapper = styled.div<ModalProps>`
  position: fixed;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  overflow-x: hidden;
  overflow-y: scroll;
  transition: 0.8s ease-in-out;

  background-color: ${(props) => props.background};
`;

const StyledModalWrapper = styled.div<ModalProps>`
  position: relative;
  opacity: 1;
  transition: opacity 250ms 250ms ease, transform 300ms 250ms ease;
  z-index: 100;
  margin: auto;

  background-color: ${(props) => props.backgroundColor};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  min-width: ${(props) => props.minWidth};
`;

export const Modal: React.FC<ModalProps> = ({
  background = config.white,
  backgroundColor = config.white,
  width = 'unset',
  maxWidth = 'unset',
  minWidth = 'unset',
  children,
  // additional props
  ...props
}) => {
  return (
    <StyledWrapper
      background={background}
      // any additional props that override the defaults
      {...props}
    >
      <StyledModalWrapper
        width={width}
        maxWidth={maxWidth}
        minWidth={minWidth}
        backgroundColor={backgroundColor}
      >
        {children}
      </StyledModalWrapper>
    </StyledWrapper>
  );
};
